import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { SiteFooter } from '../components/SiteFooter';

const LAST_UPDATED = '18 de mayo de 2025';
const COMPANY = 'ZettaPost';
const NIF = '70941839';
const EMAIL = 'hola@zettapost.com';
const ADDRESS = 'Calle Consuelo 20, Oficina 3, 37001 Salamanca (España)';
const DOMAIN = 'zettapost.com';

export function Terms() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-14">

        {/* header */}
        <div className="mb-10">
          <p className="text-xs uppercase tracking-widest text-brand-600 font-semibold mb-2">Legal</p>
          <h1 className="text-3xl font-extrabold text-slate-900">Términos y Condiciones</h1>
          <p className="mt-2 text-sm text-slate-400">Última actualización: {LAST_UPDATED}</p>
        </div>

        <div className="prose prose-slate max-w-none space-y-10">

          <Section title="1. Objeto y aceptación">
            <p>Los presentes Términos y Condiciones (en adelante, "Términos") regulan el acceso y uso del servicio web <strong>{DOMAIN}</strong> y la aplicación {COMPANY} (en adelante, "el Servicio"), titularidad de:</p>
            <ul>
              <li><strong>Razón social:</strong> {COMPANY}</li>
              <li><strong>NIF:</strong> {NIF}</li>
              <li><strong>Domicilio:</strong> {ADDRESS}</li>
              <li><strong>Contacto:</strong> <a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
            </ul>
            <p>El acceso y uso del Servicio implica la aceptación plena y sin reservas de estos Términos. Si no estás de acuerdo, debes abstenerte de utilizar el Servicio.</p>
          </Section>

          <Section title="2. Descripción del servicio">
            <p>{COMPANY} es una plataforma SaaS (Software as a Service) de gestión y programación de contenidos en redes sociales que permite a sus usuarios:</p>
            <ul>
              <li>Conectar cuentas de redes sociales (Instagram, X/Twitter, LinkedIn, Facebook, TikTok, YouTube, Pinterest, Threads y Bluesky).</li>
              <li>Crear, programar y publicar contenido (texto, imágenes y vídeo) en múltiples redes sociales simultáneamente.</li>
              <li>Gestionar una biblioteca de archivos multimedia.</li>
              <li>Visualizar previsualizaciones del contenido antes de publicarlo.</li>
              <li>Acceder a métricas básicas de publicaciones.</li>
            </ul>
            <p>{COMPANY} se reserva el derecho de modificar, ampliar o limitar las funcionalidades del Servicio en cualquier momento, notificándolo con razonable antelación cuando los cambios sean sustanciales.</p>
          </Section>

          <Section title="3. Registro y cuenta de usuario">
            <p>Para acceder al Servicio es necesario crear una cuenta. Al registrarte, te comprometes a:</p>
            <ul>
              <li>Proporcionar información veraz, actualizada y completa.</li>
              <li>Mantener la confidencialidad de tus credenciales de acceso.</li>
              <li>Notificarnos inmediatamente en caso de acceso no autorizado a tu cuenta.</li>
              <li>Ser mayor de 16 años o contar con el consentimiento de tu tutor legal.</li>
            </ul>
            <p>Eres el único responsable de todas las actividades realizadas desde tu cuenta. {COMPANY} no será responsable de los daños derivados del incumplimiento de estas obligaciones.</p>
          </Section>

          <Section title="4. Condiciones de uso aceptable">
            <p>Queda expresamente prohibido:</p>
            <ul>
              <li>Publicar contenido ilegal, difamatorio, obsceno, discriminatorio, que incite al odio o que infrinja derechos de terceros.</li>
              <li>Realizar spam, publicidad no solicitada o cualquier actividad que viole las políticas de uso de las redes sociales conectadas.</li>
              <li>Intentar acceder a cuentas o datos de otros usuarios.</li>
              <li>Usar el Servicio para actividades fraudulentas o que puedan dañar la reputación de {COMPANY} o de terceros.</li>
              <li>Realizar ingeniería inversa, descompilar o intentar extraer el código fuente del Servicio.</li>
              <li>Sobrecargar los sistemas mediante bots, scrapers u otros medios automatizados no autorizados.</li>
              <li>Revender, sublicenciar o transferir el acceso al Servicio a terceros sin autorización expresa.</li>
            </ul>
            <p>El incumplimiento de estas normas podrá conllevar la suspensión o cancelación inmediata de la cuenta sin derecho a reembolso.</p>
          </Section>

          <Section title="5. Planes, precios y facturación">
            <p>{COMPANY} ofrece un período de prueba gratuito cuyas condiciones se detallan en la página de precios. Transcurrido dicho período, el acceso continuado al Servicio requerirá la contratación de un plan de pago.</p>
            <ul>
              <li>Los precios se muestran en euros (€) e incluyen el IVA aplicable.</li>
              <li>La facturación es periódica (mensual o anual según el plan elegido) y se renueva automáticamente salvo cancelación previa.</li>
              <li>El pago se realiza mediante los métodos habilitados en la plataforma (tarjeta de crédito/débito u otros procesadores de pago).</li>
              <li>Los cambios de plan surten efecto en el siguiente período de facturación.</li>
            </ul>
          </Section>

          <Section title="6. Política de cancelación y reembolso">
            <ul>
              <li>Puedes cancelar tu suscripción en cualquier momento desde la configuración de tu cuenta.</li>
              <li>La cancelación tendrá efecto al final del período de facturación en curso, conservando el acceso hasta dicha fecha.</li>
              <li>No se realizarán reembolsos por períodos parcialmente utilizados, salvo en los casos previstos por la legislación española de consumidores o cuando {COMPANY} lo considere oportuno.</li>
              <li>Derecho de desistimiento: los usuarios que sean consumidores disponen de <strong>14 días naturales</strong> desde la contratación para ejercer el derecho de desistimiento conforme al Real Decreto Legislativo 1/2007, salvo que el servicio haya comenzado a prestarse con consentimiento expreso del usuario.</li>
            </ul>
          </Section>

          <Section title="7. Propiedad intelectual">
            <p><strong>Del Servicio:</strong> {COMPANY} y sus licenciantes son titulares de todos los derechos de propiedad intelectual sobre el Servicio, su diseño, código, marca, logotipos y contenidos propios. Nada en estos Términos te otorga derechos sobre ellos más allá del uso necesario para utilizar el Servicio.</p>
            <p><strong>De tu contenido:</strong> conservas todos los derechos sobre el contenido que creas y publicas a través del Servicio. Al usar {COMPANY}, nos concedes una licencia limitada, no exclusiva y gratuita para procesar, almacenar y publicar dicho contenido exclusivamente con el fin de prestar el Servicio.</p>
          </Section>

          <Section title="8. Disponibilidad y mantenimiento">
            <p>{COMPANY} se esfuerza por ofrecer una disponibilidad del servicio del 99,5 % mensual, pero no garantiza un funcionamiento ininterrumpido. Podrán producirse interrupciones por mantenimiento programado, fallos técnicos o causas de fuerza mayor.</p>
            <p>No seremos responsables de los daños causados por interrupciones del servicio, fallos de conectividad o cambios en las APIs de terceros (redes sociales) fuera de nuestro control.</p>
          </Section>

          <Section title="9. Limitación de responsabilidad">
            <p>En la máxima medida permitida por la ley:</p>
            <ul>
              <li>{COMPANY} no será responsable de daños indirectos, incidentales, especiales o consecuentes derivados del uso o la imposibilidad de uso del Servicio.</li>
              <li>La responsabilidad total de {COMPANY} frente al usuario no superará el importe pagado por el Servicio durante los <strong>3 meses anteriores</strong> al evento que originó la reclamación.</li>
              <li>No garantizamos que el Servicio cumpla con los requisitos específicos de cada plataforma de redes sociales, cuyos términos y APIs pueden cambiar sin previo aviso.</li>
            </ul>
          </Section>

          <Section title="10. Modificación de los Términos">
            <p>Nos reservamos el derecho de modificar estos Términos en cualquier momento. Las modificaciones sustanciales se notificarán con al menos <strong>15 días de antelación</strong> por correo electrónico o mediante un aviso destacado en la plataforma. El uso continuado del Servicio tras la entrada en vigor de los nuevos Términos implicará su aceptación.</p>
          </Section>

          <Section title="11. Suspensión y cancelación de cuentas">
            <p>{COMPANY} podrá suspender o cancelar tu cuenta, con o sin previo aviso, en los siguientes supuestos:</p>
            <ul>
              <li>Incumplimiento de estos Términos.</li>
              <li>Falta de pago reiterada.</li>
              <li>Uso fraudulento o perjudicial para el Servicio o terceros.</li>
              <li>Requerimiento de autoridades competentes.</li>
            </ul>
            <p>Tras la cancelación, dispondrás de <strong>30 días</strong> para exportar tu contenido antes de que sea eliminado definitivamente de nuestros sistemas.</p>
          </Section>

          <Section title="12. Ley aplicable y jurisdicción">
            <p>Estos Términos se rigen por la legislación española. Para la resolución de cualquier controversia derivada de la interpretación o cumplimiento de estos Términos, las partes se someten, con renuncia expresa a cualquier otro fuero, a los Juzgados y Tribunales de <strong>Salamanca (España)</strong>, salvo que la normativa aplicable establezca una jurisdicción distinta en favor del usuario como consumidor.</p>
            <p>Asimismo, la Comisión Europea pone a disposición de los consumidores de la UE una plataforma de resolución de litigios en línea: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">ec.europa.eu/consumers/odr</a>.</p>
          </Section>

          <Section title="13. Contacto">
            <p>Para cualquier consulta sobre estos Términos:</p>
            <ul>
              <li><strong>Email:</strong> <a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
              <li><strong>Dirección postal:</strong> {ADDRESS}</li>
            </ul>
          </Section>

        </div>

        {/* footer nav */}
        <div className="mt-14 pt-6 border-t border-slate-200 flex flex-wrap gap-4 text-sm text-slate-500">
          <Link to="/" className="hover:text-slate-700">← Volver al inicio</Link>
          <Link to="/privacy" className="hover:text-slate-700">Política de Privacidad</Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-lg font-bold text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3 text-slate-600 text-sm leading-relaxed [&_a]:text-brand-600 [&_a]:hover:underline [&_ul]:mt-2 [&_ul]:space-y-1.5 [&_ul]:pl-5 [&_ul]:list-disc [&_strong]:text-slate-800">
        {children}
      </div>
    </section>
  );
}
